import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';
import DropDownMenu from '../DropDownMenu.jsx';
import {signout as SignoutAction} from 'actions/auth/SignoutAction';
import {allowedAccountResources} from 'constants/Combobet';

import { isRingo } from 'shared/domainUtils'

const messages = defineMessages({
    title: {
        id: 'header.user_menu.title',
        defaultMessage: 'Профиль'
    },
    accountNum: {
        id: 'header.user_menu.account_num',
        defaultMessage: 'Номер счета'
    },
    recharge: {
        id: 'header.user_menu.recharge',
        defaultMessage: 'Пополнить баланс'
    },
    briefcase: {
        id: 'header.user_menu.briefcase',
        defaultMessage: 'Портфель ставок'
    },
    betHistory: {
        id: 'header.user_menu.bet_history',
        defaultMessage: 'История ставок'
    },
    accountHistory: {
        id: 'header.user_menu.account_history',
        defaultMessage: 'История счета'
    },
    withdraw: {
        id: 'header.user_menu.withdraw',
        defaultMessage: 'Снять со счета'
    },
    opexСhecks: {
        id: 'header.user_menu.opex_checks',
        defaultMessage: 'Чеки «Opex»'
    },
    usdtСhecks: {
        id: 'header.user_menu.usdt_checks',
        defaultMessage: 'Чеки «USD₮»'
    },
    profile: {
        id: 'header.user_menu.profile',
        defaultMessage: 'Мой профиль'
    },
    bonus: {
        id: 'header.user_menu.bonus',
        defaultMessage: "Бонусы"
    },
    logout: {
        id: 'header.user_menu.logout',
        defaultMessage: 'Выйти'
    }
});

function _localizedLink(message, link, additionalClass) {
    let linkClass = "dropdown--menu__link";
    if (additionalClass) {
        linkClass = `${linkClass} ${additionalClass}`;
    }

    return (
        <FormattedMessage {...message}>
            {(localizedMessage) =>
            <a href={link} target="_blank" className={linkClass} onClick={_handleClick.bind(null, link)}>
                {localizedMessage}
            </a>}
        </FormattedMessage>
    );
}

function _handleClick(link, e) {
    e.preventDefault();

    window.open(link, 'MyAccount',
        "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
}

class UserDropDownMenu extends React.Component {
    static propTypes = {
        user: React.PropTypes.any,
        domain: React.PropTypes.string.isRequired,
        onClosing: React.PropTypes.func.isRequired,
        accountNum: React.PropTypes.string.isRequired,
        SignoutAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._handleLogout = this._handleLogout.bind(this);
    }

    _handleLogout() {
        this.props.SignoutAction();
    }

    _renderTitle() {
        const accountNum = this.props.accountNum;

        return (
            <div>
                <FormattedMessage {...messages.accountNum}/>
                {':'}&nbsp;
                <span style={{color:'#ffea00'}}>{accountNum}</span>
            </div>
        );
    }

    render() {
        const cssClass = 'dropdown--menu-user';

        const {domain, user} = this.props;
        const isKGZDemoUser = user && user.get('accountNum') === '276502';

        const LogoutLink = (
            <FormattedMessage {...messages.logout}>
                {(localizedMessage) =>
                    <a href="#" className="dropdown--menu__link" onClick={this._handleLogout}>
                        {localizedMessage}
                    </a>}
            </FormattedMessage>
        );

        let elements = [
            isRingo ? null : {content: _localizedLink(messages.recharge, `//members.${domain}/balance/recharge`)},
            {content: _localizedLink(messages.briefcase, `//members.${domain}/balance/briefcase`)},
            {content: _localizedLink(messages.betHistory, `//members.${domain}/history/bets`)},
            {content: _localizedLink(messages.accountHistory, `//members.${domain}/history/account`)},
            {content: _localizedLink(messages.withdraw, `//members.${domain}/balance/withdraw`)},
            {content: _localizedLink(messages.profile, `//members.${domain}/profile`)},
            {content: _localizedLink(messages.bonus, `//members.${domain}/bonus`, 'bonus-link')},
            {content: LogoutLink}
        ];

        if (allowedAccountResources.find(accountResource => accountResource === user.get('resourceId'))) {
            elements = [
                isRingo ? null : {content: _localizedLink(messages.recharge, `//members.${domain}/balance/recharge`)},
                {content: _localizedLink(messages.briefcase, `//members.${domain}/balance/briefcase`)},
                {content: _localizedLink(messages.betHistory, `//members.${domain}/history/bets`)},
                {content: _localizedLink(messages.accountHistory, `//members.${domain}/history/account`)},
                {content: _localizedLink(messages.withdraw, `//members.${domain}/balance/withdraw`)},
                {content: _localizedLink(messages.opexСhecks, `//members.${domain}/opex-checks`)},
                isKGZDemoUser ? {content: _localizedLink(messages.usdtСhecks, `//members.${domain}/usdt-checks`)} : null,
                {content: _localizedLink(messages.profile, `//members.${domain}/profile`)},
                {content: _localizedLink(messages.bonus, `//members.${domain}/bonus`, 'bonus-link')},
                {content: LogoutLink}
            ];
        }

        const title = this._renderTitle();

        return (
            <DropDownMenu cssClass={cssClass}
                          title={title}
                          elements={elements}
                          onClosing={this.props.onClosing}
            />
        );
    }
}

function select(state) {
    const domain =  window.location.host === "qa1.fp.kz" ? 'qa1.fp.kz' : state.domain;
    return {
        domain,
        user: state.auth.get('user')
    };
}

export default connect(select,{SignoutAction})(UserDropDownMenu);



// WEBPACK FOOTER //
// ./js/sport-betting/components/header/UserDropDownMenu.jsx